document.addEventListener("DOMContentLoaded", function() {
   const isMobile = window.innerWidth <= 768;
    if (isMobile) {
      document.querySelector('.shopify-section.section-gallery').style.display = 'block';
      document.querySelector('.shopify-section.section-scrolling-boxes').style.display = 'none';
    } else {
      document.querySelector('.shopify-section.section-gallery').style.display = 'none';
      document.querySelector('.shopify-section.section-scrolling-boxes').style.display = 'block';
    }
});
